import { getRelativeTime } from '@thoughtspot/date-format-util';
import { translate as t } from '@thoughtspot/i18n';
import { ErrorCode } from '@thoughtspot/radiant-react/widgets/alert/alert-constants';
import { MutedAlert } from '@thoughtspot/radiant-react/widgets/alert/muted/muted-alert';
import { Button } from '@thoughtspot/radiant-react/widgets/button';
import { TableListView } from '@thoughtspot/radiant-react/widgets/table/table-list-view';
import { CellType } from '@thoughtspot/radiant-react/widgets/table/table-list-view/cell/cell-type-service';
import { EmptyCell } from '@thoughtspot/radiant-react/widgets/table/table-list-view/cell/empty-cell/empty-cell';
import { getCurrentOrgId } from '@thoughtspot/session-service';
import _ from 'lodash';
import React, { useMemo, useState } from 'react';
import { DEFAULT_ORG_ID as ALL_ORG_ID, isFileEditAllowed, } from "../../../utils/chart-customization";
import { Horizontal } from "../../../utils/layouts";
import styles from './custom-chart.module.scss';
const getCustomChartListColumns = () => [
    {
        headerName: t('customChart.list.name.label'),
        colId: 'name',
        field: 'name',
        flex: 2,
        sortable: true,
        cellRenderer: CellType[CellType.text],
    },
    {
        headerName: t('customChart.list.name.uploadedBy'),
        colId: 'uploadedBy',
        field: 'uploadedBy',
        flex: 2,
        sortable: true,
        isNameLink: false,
        cellRenderer: CellType[CellType.avatar],
    },
    {
        headerName: t('customChart.list.name.lastModified'),
        colId: 'lastModified',
        field: 'lastModified',
        flex: 2,
        sortable: true,
        cellRenderer: CellType[CellType.text],
    },
    {
        cellRenderer: (params) => (React.createElement(EmptyCell, { ...params }, (cellValues) => (React.createElement(Horizontal, { vAlignContent: "center" },
            React.createElement(Button, { type: "tertiary", text: t('customChart.list.action.edit'), size: "m", id: cellValues.editKey, onClick: cellValues.rowEditFunction, isDisabled: !!cellValues.disableUpdateMsg, tooltip: cellValues.disableUpdateMsg, "data-testid": `edit-customChart-btn-${cellValues.dataTestIdSuffix}` }),
            React.createElement(Button, { type: "tertiary", text: t('customChart.list.action.delete'), size: "m", id: cellValues.deleteKey, onClick: cellValues.rowDeleteFunction, isDisabled: !!cellValues.disableUpdateMsg, tooltip: cellValues.disableUpdateMsg, "data-testid": `delete-customChart-btn-${cellValues.dataTestIdSuffix}` }))))),
        colId: 'actions',
        flex: 1,
        sortable: false,
    },
];
const COL_ID_TO_FIELD_MAP = {
    uploadedBy: 'modifiedByName',
    name: 'name',
    lastModified: 'modified',
};
const EmptyChartList = ({ onAddChart }) => (React.createElement(MutedAlert, { global: true, imageVisible: true, errorCode: ErrorCode.GLOBAL_SEARCH, title: t('chartCustomization.customCharts.content.noData.title'), description: t('chartCustomization.customCharts.content.noData.description'), className: styles.mutedAlertContainer, primaryAction: {
        label: t('chartCustomization.customCharts.content.addChart'),
        onClick: onAddChart,
    } }));
export const CustomChartListComponent = ({ customChartList, onEditChartButtonClick, onDeleteChartButtonClick, onAddChartButtonClick, loading = false, currentOrgId = ALL_ORG_ID, }) => {
    const [sortOrder, setSortOrder] = useState([null, null, null]);
    const handleSortChange = (sortState) => {
        setSortOrder(sortState);
    };
    const userOrgId = currentOrgId === ALL_ORG_ID ? currentOrgId : getCurrentOrgId();
    const parsedData = useMemo(() => {
        const sortCol = sortOrder.find((col) => col?.colId);
        return _.chain(customChartList)
            .orderBy([COL_ID_TO_FIELD_MAP[sortCol?.colId]], [sortCol?.sort])
            .map(chart => {
            return {
                id: chart.id,
                name: { text: chart.name },
                uploadedBy: [
                    {
                        name: chart.modifiedByName,
                        id: chart.modifiedBy,
                    },
                ],
                lastModified: { text: getRelativeTime(chart.modified) },
                actions: {
                    dataTestIdSuffix: chart.name,
                    editKey: chart.id,
                    deleteKey: chart.id,
                    disableUpdateMsg: !isFileEditAllowed(userOrgId, chart)
                        ? t('customChart.update.disabled.orgBlocker')
                        : null,
                    rowEditFunction: () => onEditChartButtonClick(chart.id),
                    rowDeleteFunction: () => onDeleteChartButtonClick(chart.id),
                },
            };
        })
            .value();
    }, [customChartList, sortOrder]);
    if (!loading && !customChartList?.length) {
        return React.createElement(EmptyChartList, { onAddChart: () => onAddChartButtonClick() });
    }
    return (React.createElement(TableListView, { data: parsedData, options: {}, columns: getCustomChartListColumns(), loading: loading, sortingOrder: sortOrder, onSortingChanged: handleSortChange }));
};
//# sourceMappingURL=custom-chart-list.component.js.map